<template>
  <!-- 忘記密碼-手機版 -->
  <div class="mobile-login">
    <div class="content">
      <div class="form-wrap">
        <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('username') }">
          <label for="">
            <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-account.png`)" alt=""></i>
            {{ $t('Bao.registered_account_require') }}
          </label>
          <input
            v-model="postForm.username"
            v-validate="'required'"
            type="text"
            name="username"
            :data-vv-as="$t('Bao.username')"
            :placeholder="$t('Bao.registered_account')"
            :required="true"
            autocomplete="off"
          >
          <div v-if="errors.has('username')" class="help-block">
            {{ $t("Bao.user_name_error") }}
          </div>
        </div>

        <span class="h5">{{ $t('Bao.registered_email_require') }}</span>
        <div>
          <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('check_email') }">
            <input
              v-model="postForm.email"
              v-validate="'required'"
              :placeholder="$t('Bao.registered_email')"
              type="email"
              name="check_email"
            >
            <div v-if="errors.has('check_email')" class="help-block">
              {{ $t("Bao.email_error") }}
            </div>
          </div>
        </div>
      </div>
      <!-- 驗證碼彈窗 與PM確認後為多餘的設計 按舊專案做-->
      <!-- <div class="desktop-form-popup" :class="{ active: isVerify }">
          <div class="form-popup">
            <div class="inner">
              <p>Please enter the code.</p>
              <input type="text">
              <div class="verify-button">
                <button class="button-style-10">
                  <span>Verify</span>
                </button>
                <button class="button-style-9" @click="closeVerify">
                  <span>Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div> -->
      <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-style-primary-golden btn-w-xl" :disabled="actionLoading" type="button" @click="handleUpdate">
          <span>{{ $t("Bao.send") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { requestForgotPassword, getPhoneCode } from '@/api/user'
import { setErrorMessage, showNotice } from '@/utils/tool'

export default {
  name: 'Forget',

  data() {
    const postForm = {
      username: null,
      email: null
    }

    return {
      actionLoading: false,
      postForm,
      limitVerify: false,
      gettingVerify: false,
      limitSecond: 300,
      previousPhone: '',
      isVerify: false,
      isFlagShow: false,
      login_bg: this.$store.state.brand.brandImage.login_banner !== undefined ? this.$store.state.brand.brandImage.login_banner[0].image : ''
    }
  },
  methods: {
    getCode() {
      this.gettingVerify = true
      if (this.postForm.phone !== this.previousPhone) {
        this.postForm.phone = this.formatPhoneNumber(this.postForm.phone)
        this.previousPhone = this.postForm.phone
      }
      getPhoneCode({ phone: this.postForm.phone, type: 1 }).then(response => {
        showNotice(response.data.msg)
        this.countDown()
        this.gettingVerify = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
        this.gettingVerify = false
      })
    },
    formatPhoneNumber(input) {
      const str = '' + input
      return '+81 ' + str.slice(0, 2) + '-' + str.slice(2, 6) + '-' + str.slice(6)
    },
    countDown() {
      this.limitVerify = true
      this.limitSecond = 300
      const clock = window.setInterval(() => {
        this.limitSecond--
        if (this.limitSecond < 0) {
          this.limitVerify = false
          window.clearInterval(clock)
        }
      }, 1000)
    },
    handleUpdate() {
      const self = this
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.actionLoading = true
          requestForgotPassword(this.postForm).then(response => {
            this.postForm = {}
            this.limitVerify = false
            showNotice(this.$t('Bao.send_email_success'), function() {
              self.$store.commit('SET_CAMP_FORGET_OPEN', false)
              self.$store.commit('SET_CAMP_LOGIN_OPEN', true)
            }, true, false, true)
          }).catch((error) => {
            setErrorMessage(error.response, this.errors)
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    },
    toggleFlagShow() {
      this.isFlagShow = !this.isFlagShow
    },
    openVerify() {
      this.isVerify = true
    },
    closeVerify() {
      this.isVerify = false
    },
    deactivatePopup() {
      this.$store.commit('SET_FORGET_OPEN', false)
      this.errors.clear()
    }
  }
}
</script>
<style scoped>
  .mobile-login {
    z-index: 10;
  }
</style>
